<template>
  <div id="SingleCollectionPage" class="grey darken-4 main-content">
    <LeftNav v-if="!this.$route.params.collectionId" />
    <v-main>
      <CollectionToolbar
        :collectionName="collection.name"
        :collectionId="collection.id"
        :imageCount="total"
      />
      <v-container fluid class="pt-12">
        <div class="pt-8 whitetext">Total: {{ total }}</div>
        <v-layout row wrap align-center justify-center class="pa-4">
          <SingleImage
            v-for="(photo, index) in photos"
            :key="index"
            :index="index"
            :photo="photo"
          />
        </v-layout>

        <infinite-loading @infinite="loadCollection">
          <div class="whitetext" slot="spinner">Loading...</div>
          <div class="whitetext" slot="no-more">No more images</div>
          <div class="whitetext" slot="no-results">No images</div>
        </infinite-loading>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import {
  FETCH_COLLECTION,
  SET_ACTIVE_EXPCLIENT,
  FETCH_EXPCLIENT,
  COLLECTION_RESET_STATE,
  PHOTO_SEARCH_RESET,
} from "@/store/actions.type";

export default {
  name: "SingleCollectionPage",
  props: {
    collectionId: null,
    clientId: null,
  },

  computed: {
    photos() {
      if (typeof this.collection.photos == "undefined") return [];
      if (this.collection.photos.data.length > 0)
        return this.imageSearchResult.data;

      return [];
    },
    total() {
      if (typeof this.collection.photos == "undefined") return "";
      if (this.collection.photos.data.length > 0)
        return this.collection.photos.total;
      return "";
    },
    ...mapGetters(["collection", "activeExpClient", "imageSearchResult"]),
  },
  methods: {
    loadCollection($state) {
      store
        .dispatch(FETCH_COLLECTION, {
          clientId: this.$route.params.clientId,
          collectionId: this.$route.params.collectionId,
        })
        .then((result) => {
          if (result == "complete") {
            $state.complete();
          }
          $state.loaded();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    // store.dispatch(FETCH_COLLECTION, {clientId:this.$route.params.clientId, collectionId:this.$route.params.collectionId})
  },
  destroyed() {
    store.dispatch(COLLECTION_RESET_STATE);
    store.dispatch(PHOTO_SEARCH_RESET);
  },
};
</script>
